@if (modal_name) {
<div class="modal-header">
    <h3 class="modal-title">{{ modalTitle }}</h3>
    <div class="header-actions">
      <i class="fa" 
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
         style="margin-right: 10px; cursor: pointer;" 
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>
}
  
  <div class="modal-body" [class.no-body-scroll]="modal_name" [hidden]="minimise">
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
  
    @if (!showFormLoader) {
<div class="form-horizontal">
      <div class="form-group">
        <div class="col-md-6 date-field-inline">
          <label>Beginning period (MM/DD/YYYY):</label>
          <input type="date" class="form-control form-control--date"
            [ngModel]="attribData['8858_NA_FDE_BEGIN_DATE']"
            (ngModelChange)="attribData['8858_NA_FDE_BEGIN_DATE']=$event">
        </div>
        <div class="col-md-6 date-field-inline">
          <label>Ending period (MM/DD/YYYY):</label>
          <input type="date" class="form-control form-control--date"
            [ngModel]="attribData['8858_NA_FDE_END_DATE']"
            (ngModelChange)="attribData['8858_NA_FDE_END_DATE']=$event">
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-6">Filing Group</label>
        <div class="col-md-6">
          <select class="form-control" [ngModel]="selectedGroup" (ngModelChange)="selectedGroup=$event; updated($event && $event.LEGAL_ENTITY_ID)">
            <option [ngValue]="null">Select Filing Group</option>
            @for (fg of filingGroup; track $index) {
<option [ngValue]="fg">{{ fg.LEGAL_ENTITY_NAME }}</option>
}
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6">
          <label>Name of person filing this return:</label>
          <div>{{ selectedGroup?.LEGAL_ENTITY_NAME }}</div>
        </div>
        <div class="col-md-6">
          <div class="pull-left">Filer's Identifying Number<br />{{ selectedGroup?.FILER_EIN || '' }}</div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6"><label>Number, Street and Room or Suite No.</label><div>{{ selectedGroup?.FILER_ADDR_LINE1 }}</div></div>
        <div class="col-md-6"><div class="pull-left">City or Town, State and Zip code<br />{{ selectedGroup?.FILER_ADDR_LINE2 }}</div></div>
      </div>
      <div class="form-group">
        <div class="col-md-12"><b>Filer's tax year</b></div>
        <div class="col-md-6"><label>Beginning period (MM/DD/YYYY):</label><div>{{ selectedGroup?.FILER_TAX_YEAR_BEGIN | date:'MM/dd/yyyy' }}</div></div>
        <div class="col-md-6"><label>Ending period (MM/DD/YYYY):</label><div>{{ selectedGroup?.FILER_TAX_YEAR_END | date:'MM/dd/yyyy' }}</div></div>
      </div>
      <div class="form-group form-group--radio-inline">
        <div class="col-md-6 form-label">
          <div class="radio-options-inline">
            <label class="radio-option">
              <input type="radio" name="radioIn" value="I" [ngModel]="radioIn" (ngModelChange)="radioIn=$event"/>
              <span><b>Initial 8858</b></span>
            </label>
            <label class="radio-option">
              <input type="radio" name="radioIn" value="F" [ngModel]="radioIn" (ngModelChange)="radioIn=$event"/>
              <span><b>Final 8858</b></span>
            </label>
            <label class="radio-option">
              <input type="radio" name="radioIn" value="N" [ngModel]="radioIn" (ngModelChange)="radioIn=$event"/>
              <span><b>N/A</b></span>
            </label>
          </div>
        </div>
        <div class="col-md-6 form-value"></div>
      </div>
      <div class="form-section form-section--1a">
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">1a. a.</span>Name of foreign disregarded entity</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_FDE_FB_NAME_1']" (ngModelChange)="attribData['8858_NA_FDE_FB_NAME_1']=$event" readonly></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Address of foreign corporation</div>
        <div class="col-md-6 form-value"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Country</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="countryVar" (ngModelChange)="countryVar=$event" disabled>
            <option value="">Select Country</option>
            @for (c of countries; track $index) {
<option [value]="c.COUNTRY_CODE">{{ c.COUNTRY_CODE }} - {{ c.COUNTRY_NAME }}</option>
}
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Line 1:</div>
        <div class="col-md-6 form-value">
          @if (countryVar !== 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_F_ADDR_1']" (ngModelChange)="attribData['8858_NA_FDE_FB_F_ADDR_1']=$event" readonly>
}
          @if (countryVar === 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_US_ADDR_1']" (ngModelChange)="attribData['8858_NA_FDE_FB_US_ADDR_1']=$event" readonly>
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Line 2:</div>
        <div class="col-md-6 form-value">
          @if (countryVar !== 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_F_ADDR_2']" (ngModelChange)="attribData['8858_NA_FDE_FB_F_ADDR_2']=$event" readonly>
}
          @if (countryVar === 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_US_ADDR_2']" (ngModelChange)="attribData['8858_NA_FDE_FB_US_ADDR_2']=$event" readonly>
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">City:</div>
        <div class="col-md-6 form-value">
          @if (countryVar !== 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_F_CITY']" (ngModelChange)="attribData['8858_NA_FDE_FB_F_CITY']=$event" readonly>
}
          @if (countryVar === 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_US_CITY']" (ngModelChange)="attribData['8858_NA_FDE_FB_US_CITY']=$event" readonly>
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">State:</div>
        <div class="col-md-6 form-value">
          @if (countryVar === 'US') {
<select class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_US_STATE'] || ''" (ngModelChange)="attribData['8858_NA_FDE_FB_US_STATE']=$event" readonly>
            <option value="">Select State</option>
            @for (s of states; track $index) {
<option [value]="s.CODE">{{ s.CODE }} - {{ s.NAME }}</option>
}
          </select>
}
          @if (countryVar !== 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_F_STATE']" (ngModelChange)="attribData['8858_NA_FDE_FB_F_STATE']=$event" readonly>
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Zip/Postal Code:</div>
        <div class="col-md-6 form-value">
          @if (countryVar !== 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_F_ZIP']" (ngModelChange)="attribData['8858_NA_FDE_FB_F_ZIP']=$event" readonly>
}
          @if (countryVar === 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_FDE_FB_US_ZIP']" (ngModelChange)="attribData['8858_NA_FDE_FB_US_ZIP']=$event" readonly>
}
        </div>
      </div>
      <div class="form-group form-group--ein-row">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">b(1).</span>Identifying number (if any)</div>
        <div class="col-md-6 form-value value-column-ein">
          <input class="form-control form-control--ein" maxlength="10" type="text" [ngModel]="attribData['8858_NA_FDE_FB_EIN']" (ngModelChange)="attribData['8858_NA_FDE_FB_EIN']=$event; uncheckedRadio($event, attribData['8858_NA_FDE_FB_EIN_MISSING_REASON'], attribData['8858_NA_FDE_FB_REFERENCE_ID'])">
          <label class="radio-inline-option">
            <input type="radio" name="identify" value="APPLD FOR" [ngModel]="attribData['8858_NA_FDE_FB_EIN_MISSING_REASON']" (ngModelChange)="attribData['8858_NA_FDE_FB_EIN_MISSING_REASON']=$event; radioClicked($event, attribData['8858_NA_FDE_FB_EIN'], attribData['8858_NA_FDE_FB_REFERENCE_ID'])"/>
            <span>Applied For</span>
          </label>
          <label class="radio-inline-option">
            <input type="radio" name="identify" value="FOREIGNUS" [ngModel]="attribData['8858_NA_FDE_FB_EIN_MISSING_REASON']" (ngModelChange)="attribData['8858_NA_FDE_FB_EIN_MISSING_REASON']=$event; radioClicked($event, attribData['8858_NA_FDE_FB_EINR'], attribData['8858_NA_FDE_FB_REFERENCE_ID'])"/>
            <span>Not Applicable</span>
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">b(2).</span>Reference ID number (see instructions)</div>
        <div class="col-md-6 form-value">
          <input class="form-control" type="text" [ngModel]="attribData['8858_NA_FDE_FB_REFERENCE_ID']" (ngModelChange)="attribData['8858_NA_FDE_FB_REFERENCE_ID']=$event; ref_id($event, attribData['8858_NA_FDE_FB_EIN_MISSING_REASON'], attribData['8858_NA_FDE_FB_EIN'])" [disabled]="refrence_iddisabled === false">
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">c.</span>Country under whose laws organized</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="attribData['8858_NA_ENTITY_COUNTRY_LAWS'] || ''" (ngModelChange)="attribData['8858_NA_ENTITY_COUNTRY_LAWS']=$event; changeCountryLaws($event)">
            <option value="">Select Country</option>
            @for (c of countries; track $index) {
<option [value]="c.COUNTRY_CODE">{{ c.COUNTRY_CODE }} - {{ c.COUNTRY_NAME }}</option>
}
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">d.</span>Date of organization (DD/MM/YYYY)</div>
        <div class="col-md-6 form-value form-value--date">
          <input type="date" class="form-control"
            [ngModel]="attribData['8858_NA_ENTITY_ORGANIZATION_DATE']"
            (ngModelChange)="attribData['8858_NA_ENTITY_ORGANIZATION_DATE']=$event"
            readonly>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">e.</span>Effective date as foreign disregarded entity (DD/MM/YYYY)</div>
        <div class="col-md-6 form-value form-value--date">
          <input type="date" class="form-control"
            [ngModel]="attribData['8858_NA_FDE_EFFECTIVE_DATE']"
            (ngModelChange)="attribData['8858_NA_FDE_EFFECTIVE_DATE']=$event"
            readonly>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">f.</span>If benefits under a U.S. tax treaty were claimed with respect to income of the foreign disregarded entity, enter the treaty article number</div>
        <div class="col-md-6 form-value"><input type="text" class="form-control" [ngModel]="attribData['8858_NA_TREATY_ARTICLE_NUMBER']" (ngModelChange)="attribData['8858_NA_TREATY_ARTICLE_NUMBER']=$event; changeArticle($event)" /></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">g.</span>Country in which principal business activity is conducted</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="attribData['8858_NA_COUNTRY_PRINCIPAL_BUSINESS_ACVTY'] || ''" (ngModelChange)="attribData['8858_NA_COUNTRY_PRINCIPAL_BUSINESS_ACVTY']=$event; changePrincipalPlace($event)">
            <option value="">-----Select Principal place of business-----</option>
            @for (c of countries; track $index) {
<option [value]="c.COUNTRY_CODE">{{ c.COUNTRY_CODE }} - {{ c.COUNTRY_NAME }}</option>
}
          </select>
        </div>
      </div>
      @if (tax_year <= '2023') {
<div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">h.</span>Principal business activity</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="attribData['8858_NA_PRINCIPAL_ACTIVITY_CODE'] || ''" (ngModelChange)="updated2($event)">
            <option value="">Select Principal Business Activity</option>
            @for (p of PrincipalBusinessActivity; track $index) {
<option [value]="p.ACTIVITY_DESC">{{ p.ACTIVITY_CODE }} - {{ p.ACTIVITY_DESC }}</option>
}
          </select>
        </div>
      </div>
}
      @if (tax_year >= '2024') {
<div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-nested"><span class="label-prefix">h.</span>Principal business activity code number</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="attribData['8858_NA_PRINCIPAL_ACTIVITY_CODE'] || ''" (ngModelChange)="updated1($event)">
            <option value="">Select Principal Business Activity</option>
            @for (p of PrincipalBusinessActivity; track $index) {
<option [value]="p.ACTIVITY_CODE">{{ p.ACTIVITY_CODE }} - {{ p.ACTIVITY_DESC }}</option>
}
          </select>
        </div>
      </div>
}
      @if (tax_year >= '2024') {
<div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">i.</span>Principal business activity</div>
        <div class="col-md-6 form-value"><input type="text" [ngModel]="attribData['8858_NA_PRINCIPAL_BUSINESS_ACTIVITY']" class="form-control" readonly></div>
      </div>
}
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter"><span class="label-prefix">@if (tax_year <= '2023') {
<span>i.</span>
}@if (tax_year >= '2024') {
<span>j.</span>
}</span>Functional currency</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="attribData['8858_NA_FUNCTIONAL_CURRENCY'] || ''" (ngModelChange)="attribData['8858_NA_FUNCTIONAL_CURRENCY']=$event" disabled>
            <option value="">Select Functional Currency</option>
            @for (cur of currencies; track $index) {
<option [value]="cur.CURR_CODE">{{ cur.CURR_CODE }} - {{ cur.CURR_DESC }}</option>
}
          </select>
        </div>
      </div>
      </div>
      <div class="form-group"><div class="col-md-12"><span class="label-section">2.</span><b>Provide the following information for the FDE or FB accounting period stated above.</b></div></div>
      <div class="form-group"><div class="col-md-6 form-label form-label--letter label-nested"><span class="label-prefix">a.</span>Name, address, and identifying number of branch office or agent (if any) in the United States</div></div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Name Line 1:</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_US_AGENT_NAME_1']" (ngModelChange)="attribData['8858_NA_US_AGENT_NAME_1']=$event" [disabled]="batch_flag_2a"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Name Line 2:</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_US_AGENT_NAME_2']" (ngModelChange)="attribData['8858_NA_US_AGENT_NAME_2']=$event" [disabled]="batch_flag_2a"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Address Line 1:</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_US_AGENT_ADDR_1']" (ngModelChange)="attribData['8858_NA_US_AGENT_ADDR_1']=$event" [disabled]="batch_flag_2a"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Address Line 2:</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_US_AGENT_ADDR_2']" (ngModelChange)="attribData['8858_NA_US_AGENT_ADDR_2']=$event" [disabled]="batch_flag_2a"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">City:</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_US_AGENT_CITY']" (ngModelChange)="attribData['8858_NA_US_AGENT_CITY']=$event" [disabled]="batch_flag_2a"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">State:</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="attribData['8858_NA_US_AGENT_STATE'] || ''" (ngModelChange)="attribData['8858_NA_US_AGENT_STATE']=$event" [disabled]="batch_flag_2a">
            <option value="">Select State</option>
            @for (s of states; track $index) {
<option [value]="s.CODE">{{ s.CODE }} - {{ s.NAME }}</option>
}
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Zip/Postal Code:</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_US_AGENT_ZIP']" (ngModelChange)="attribData['8858_NA_US_AGENT_ZIP']=$event" [disabled]="batch_flag_2a"/></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Identifying number (if any)</div>
        <div class="col-md-6 form-value value-column-ein">
          <input class="form-control form-control--ein" maxlength="10" type="text" [ngModel]="attribData['8858_NA_US_AGENT_EIN']" (ngModelChange)="attribData['8858_NA_US_AGENT_EIN']=$event; unchecked_a()" [disabled]="batch_flag_2a">
          <label class="radio-inline-option">
            <input type="radio" name="info" value="APPLD FOR" [ngModel]="attribData['8858_NA_US_AGENT_EIN_MISSING_REASON']" (ngModelChange)="attribData['8858_NA_US_AGENT_EIN_MISSING_REASON']=$event; clicked_a()" [disabled]="batch_flag_2a"/>
            <span>Applied For</span>
          </label>
          <label class="radio-inline-option">
            <input type="radio" name="info" value="FOREIGNUS" [ngModel]="attribData['8858_NA_US_AGENT_EIN_MISSING_REASON']" (ngModelChange)="attribData['8858_NA_US_AGENT_EIN_MISSING_REASON']=$event; clicked_a()" [disabled]="batch_flag_2a"/>
            <span>Not Applicable</span>
          </label>
        </div>
      </div>
      <div class="form-group" style="padding-top: 25px;">
        <div class="col-md-6 form-label form-label--letter label-nested"><span class="label-prefix">b.</span>Name and address (including corporate department, if applicable) of person(s) with custody of the books and records of the foreign disregarded entity, and the location of such books and records, if different</div>
        <div class="col-md-6 form-value">
          <div class="radio-options-inline">
            <label class="radio-option">
              <input type="radio" name="custodyFlag" [ngModel]="attribData['8858_NA_2B_FLAG']" (ngModelChange)="attribData['8858_NA_2B_FLAG']=$event; personBnssChange()" value="P" [disabled]="batch_flag_2b"/>
              <span>Person</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="custodyFlag" [ngModel]="attribData['8858_NA_2B_FLAG']" (ngModelChange)="attribData['8858_NA_2B_FLAG']=$event; personBnssChange()" value="B" [disabled]="batch_flag_2b"/>
              <span>Business</span>
            </label>
            <label class="radio-option">
              <input type="radio" name="custodyFlag" [ngModel]="attribData['8858_NA_2B_FLAG']" (ngModelChange)="attribData['8858_NA_2B_FLAG']=$event; personBnssChange()" value="N" [disabled]="batch_flag_2b"/>
              <span>Not Applicable</span>
            </label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Name Line 1:</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_NAME_1']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_NAME_1']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Name Line 2 (allowed only if name/address type is Business):</div>
        <div class="col-md-6 form-value"><input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_NAME_2']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_NAME_2']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] !== 'B' || batch_flag_2b"></div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Country</div>
        <div class="col-md-6 form-value">
          <select class="form-control" [ngModel]="countryCust" (ngModelChange)="countryCust=$event; changeCountry(attribData['8858_NA_PERSONS_BOOK_F_COUNTRY'])" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
            <option value="">Select Country</option>
            @for (c of countries; track $index) {
<option [value]="c.COUNTRY_CODE">{{ c.COUNTRY_CODE }} - {{ c.COUNTRY_NAME }}</option>
}
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Address Line 1:</div>
        <div class="col-md-6 form-value">
          @if (countryCust !== 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_F_ADDR_1']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_F_ADDR_1']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
          @if (countryCust === 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_US_ADDR_1']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_US_ADDR_1']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Address Line 2:</div>
        <div class="col-md-6 form-value">
          @if (countryCust !== 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_F_ADDR_2']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_F_ADDR_2']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
          @if (countryCust === 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_US_ADDR_2']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_US_ADDR_2']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">City:</div>
        <div class="col-md-6 form-value">
          @if (countryCust !== 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_F_CITY']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_F_CITY']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
          @if (countryCust === 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_US_CITY']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_US_CITY']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">State:</div>
        <div class="col-md-6 form-value">
          @if (countryCust === 'US') {
<select class="form-control" [ngModel]="attribData['8858_NA_PERSONS_BOOK_US_STATE'] || ''" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_US_STATE']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
            <option value="">Select State</option>
            @for (s of states; track $index) {
<option [value]="s.CODE">{{ s.CODE }} - {{ s.NAME }}</option>
}
          </select>
}
          @if (countryCust !== 'US') {
<input type="text" class="form-control" [ngModel]="attribData['8858_NA_PERSONS_BOOK_F_STATE']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_F_STATE']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-6 form-label form-label--letter label-deep-nested">Zip/Postal Code:</div>
        <div class="col-md-6 form-value">
          @if (countryCust !== 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_F_ZIP']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_F_ZIP']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b">
}
          @if (countryCust === 'US') {
<input class="form-control" type="text" [ngModel]="attribData['8858_NA_PERSONS_BOOK_US_ZIP']" (ngModelChange)="attribData['8858_NA_PERSONS_BOOK_US_ZIP']=$event" [disabled]="attribData['8858_NA_2B_FLAG'] === 'N' || batch_flag_2b"/>
}
        </div>
      </div>
  
      <div class="form-horizontal">
        <table class="table table-bordered form-inline custom-table">
          <thead><tr><th colspan="10">{{ tabTitle[0] }}</th></tr></thead>
          <tbody>
            @for (row of scheduleGData; track $index; let i = $index) {
<tr [style.display]="row.isVisibleFlag === 'Y' ? '' : 'none'">
              <td style="padding-left: 5px;">{{ row.line_no }}</td>
              <td style="padding-left: 5px;">{{ row.line_description }}</td>
              <td class="col-md-2" style="padding-left: 5px;">
                @if (row.propertyType === '13' && row.isVisibleFlag === 'Y') {
<div class="table-radio-group">
                  <label class="table-radio-option">
                    <input type="radio" value="Y" [name]="'radioG_' + i" [checked]="row.value && row.value[0]?.VALUE === 'Y'" [disabled]="row.isEditableFlag === 'N'" (change)="onRadioBtnSelection(row, i, 'Y'); checkingForValidation(row, i)">
                    <span>Yes</span>
                  </label>
                  <label class="table-radio-option">
                    <input type="radio" value="N" [name]="'radioG_' + i" [checked]="row.value && row.value[1]?.VALUE === 'N'" [disabled]="row.isEditableFlag === 'N'" (change)="onRadioBtnSelection(row, i, 'N'); checkingForValidation(row, i)">
                    <span>No</span>
                  </label>
                </div>
}
                @if (row.propertyType === '7' && row.isVisibleFlag === 'Y') {
<div>
                  <div class="input-group">
                    <span class="input-group-addon">USD</span>
                    <input style="text-align: right; padding-left: 5px" type="text" class="form-control" 
                      [ngModel]="formatValueForDisplay(row)" 
                      (ngModelChange)="onValueChangeG(row, $event, i)" 
                      (keypress)="onNumberKeyPress($event)"
                      [disabled]="row.isEditableFlag === 'N'"/>
                  </div>
                  @if (row.isSaveValidFlagG === 'N') {
<span class="form-error-container">Please check value for line {{ row.line_no }}</span>
}
                </div>
}
              </td>
            </tr>
}
            @if (rowData.TAX_TYPE === 'BRUS' || rowData.TAX_TYPE === 'BRCFC' || rowData.TAX_TYPE === 'BRPTP') {
<tr><th colspan="10">{{ tabTitle[1] }}</th></tr>
}
            @for (row of scheduleIData; track $index; let i = $index) {
<tr [style.display]="row.isVisibleFlag === 'Y' ? '' : 'none'">
              <td style="padding-left: 5px;">{{ row.line_no }}.</td>
              <td style="padding-left: 5px;">{{ row.line_description }}</td>
              <td class="col-md-2" style="padding-left: 5px;">
                @if (row.propertyType === '13') {
<div class="table-radio-group">
                  <label class="table-radio-option">
                    <input type="radio" value="Y" [name]="'radioI_' + i" [checked]="row.value && row.value[0]?.VALUE === 'Y'" [disabled]="row.isEditableFlag !== 'Y'" (change)="onRadioBtnSelection(row, i, 'Y'); checkingForValidationForI(row, i)">
                    <span>Yes</span>
                  </label>
                  <label class="table-radio-option">
                    <input type="radio" value="N" [name]="'radioI_' + i" [checked]="row.value && row.value[1]?.VALUE === 'N'" [disabled]="row.isEditableFlag !== 'Y'" (change)="onRadioBtnSelection(row, i, 'N'); checkingForValidationForI(row, i)">
                    <span>No</span>
                  </label>
                </div>
}
                @if (row.propertyType === '7') {
<div>
                  <div class="input-group">
                    <span class="input-group-addon">USD</span>
                    <input style="text-align: right; padding-left: 5px" type="text" class="form-control" 
                      [ngModel]="formatValueForDisplay(row)" 
                      (ngModelChange)="onValueChangeI(row, $event, i)" 
                      (keypress)="onNumberKeyPress($event)"
                      [disabled]="row.isEditableFlag !== 'Y'"/>
                  </div>
                </div>
}
              </td>
            </tr>
}
          </tbody>
        </table>
      </div>
    </div>
}
  </div>
  
  @if (modal_name) {
<div class="modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" [disabled]="crudLoading" (click)="saveScheduleGData()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save and Proceed
    </button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>
}
  